import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import '../../../css/huerto/scoringTable.css';
import FunctionGeneral from '../functionsGeneral';
import usePermissions from 'hooks/usePermissions';
import oipIcon from '../../../../images/icons/denials.png';
import correoEnviadoIcon from '../../../../images/icons/correo-electronico.png';
import correoAbiertoIcon from '../../../../images/icons/sobre-abierto-con-carta.png';
import LeyendaJJVV from '../../metricas/leyendaJJVV.js';
import LeyendaContratoIncidencia from '../../metricas/leyendaContratoIncidencia';
import LeyendaContactados from '../../metricas/leyendaContactados';
import { getFlagDisplay } from '../helpers/flagDisplayHelper';
import { ProductBoxId } from 'enums/ProductEnum';

function ordenarLista(orden, data) {
    var _dataTable = [];
    if (orden.length === 2)
        //ordena el listado por el parametro establecido en el modal de ordenar
        _dataTable = new FunctionGeneral().ordenarLista(
            JSON.parse(JSON.stringify(data)),
            orden[0],
            orden[1]
        );
    else _dataTable = data;
    return _dataTable;
}

function TablaVencimientos(props) {
    const [maxPag, setMaxPag] = useState(0);
    const [li_Pag, setli_Pag] = useState([]);
    const [dataTable, setDatetable] = useState([]);
    const [listSelectVencimiento, setListSelectVencimiento] = useState(
        props.listSelectVencimiento
    );
    const [detalleSelect, setDetalleSelect] = useState('');
    const [diasAlertContacCPC, setDiasAlertContacCPC] = useState(new Date());
    const [
        diasAlertContacFINANCIACION,
        setDiasAlertContacFINANCIACION,
    ] = useState(new Date());
    const [diasAlertContacLINEAL, setDiasAlertContacLINEAL] = useState(
        new Date()
    );
    const [diasAlertContacNEXT, setDiasAlertContacNEXT] = useState(new Date());
    const [diasAlertContacRENTING, setDiasAlertContacRENTING] = useState(
        new Date()
    );
    const [diasAlertContacAUTOCREDIT, setDiasAlertContacAUTOCREDIT] = useState(
        new Date()
    );
    const [diasAlertContacREFINANCIACIONNEXT, setDiasAlertContacREFINANCIACIONNEXT] = useState(
        new Date()
    );
    const { checkPermission } = usePermissions();

    useEffect(() => {
        window.bronson.ComponentRegister.initAll();
    }, []);

    useEffect(() => {
        try {
            props.diasAlertaVencimientoToProducto.forEach(element => {
                switch (element.Constante) {
                    case 'CNST_DIAS_ALERTA_VENCIMIENTOS_CPC_HUERTO':
                        var _diasAlertContacCPC = new Date();
                        _diasAlertContacCPC.setDate(
                            diasAlertContacCPC.getDate() +
                            parseInt(element.DiasAlert)
                        );
                        setDiasAlertContacCPC(_diasAlertContacCPC);
                        break;
                    case 'CNST_DIAS_ALERTA_VENCIMIENTOS_FINANCIACION_HUERTO':
                        var _diasAlertContacFINANCIACION = new Date();
                        _diasAlertContacFINANCIACION.setDate(
                            diasAlertContacFINANCIACION.getDate() +
                            parseInt(element.DiasAlert)
                        );
                        setDiasAlertContacFINANCIACION(
                            _diasAlertContacFINANCIACION
                        );
                        break;
                    case 'CNST_DIAS_ALERTA_VENCIMIENTOS_LINEAL_HUERTO':
                        var _diasAlertContacLINEAL = new Date();
                        _diasAlertContacLINEAL.setDate(
                            diasAlertContacLINEAL.getDate() +
                            parseInt(element.DiasAlert)
                        );
                        setDiasAlertContacLINEAL(_diasAlertContacLINEAL);
                        break;
                    case 'CNST_DIAS_ALERTA_VENCIMIENTOS_NEXT_HUERTO':
                        var _diasAlertContacNEXT = new Date();
                        _diasAlertContacNEXT.setDate(
                            diasAlertContacNEXT.getDate() +
                            parseInt(element.DiasAlert)
                        );
                        setDiasAlertContacNEXT(_diasAlertContacNEXT);
                        break;
                    case 'CNST_DIAS_ALERTA_VENCIMIENTOS_RENTING_HUERTO':
                        var _diasAlertContacRENTING = new Date();
                        _diasAlertContacRENTING.setDate(
                            diasAlertContacRENTING.getDate() +
                            parseInt(element.DiasAlert)
                        );
                        setDiasAlertContacRENTING(_diasAlertContacRENTING);
                        break;
                    case 'CNST_DIAS_ALERTA_VENCIMIENTOS_AUTOCREDIT_HUERTO':
                        var _diasAlertContacAUTOCREDIT = new Date();
                        _diasAlertContacAUTOCREDIT.setDate(
                            diasAlertContacAUTOCREDIT.getDate() +
                            parseInt(element.DiasAlert)
                        );
                        setDiasAlertContacAUTOCREDIT(_diasAlertContacAUTOCREDIT);
                        break;
                    case 'CNST_DIAS_ALERTA_VENCIMIENTOS_REFINANCIACIONNEXT_HUERTO':
                        var _diasAlertContacREFINANCIACIONNEXT = new Date();
                        _diasAlertContacREFINANCIACIONNEXT.setDate(
                            diasAlertContacREFINANCIACIONNEXT.getDate() +
                            parseInt(element.DiasAlert)
                        );
                        setDiasAlertContacREFINANCIACIONNEXT(_diasAlertContacREFINANCIACIONNEXT);
                        break;
                }
            });
        } catch { }
    }, [props.diasAlertaVencimientoToProducto]);

    useEffect(() => {
        if (props.orden.length === 2)
            setDatetable(ordenarLista(props.orden, props.data));
        else setDatetable(props.data);
        setDetalleSelect('');
        props.setIndiceRowDetalle(-1);
        props.setPage(0);
    }, [props.orden]);

    useEffect(() => {
        setDatetable(ordenarLista(props.orden, props.data));
    }, [props.data]);
    useEffect(() => {
        if (props.IndiceRowDetalle === -1) setDetalleSelect('');
    }, [props.IndiceRowDetalle]);

    useEffect(() => {
        setMaxPag(
            parseInt(props.data.length / props.rowsPerPage) +
            (props.data.length % props.rowsPerPage === 0 ? -1 : 0)
        );
    }, [props.data, props.rowsPerPage]);

    useEffect(() => {
        setListSelectVencimiento(props.listSelectVencimiento);
    }, [props.listSelectVencimiento]);

    useEffect(() => {
        var new_li = [];
        var positioncalco = 0;
        if (props.page === 1) positioncalco = 1;
        else if (props.page === 0) positioncalco = 0;
        else if (props.page === maxPag) positioncalco = 4;
        else if (props.page + 1 === maxPag) positioncalco = 3;
        else if (props.page >= 2) positioncalco = 2;

        for (
            let i = props.page - positioncalco;
            new_li.length < 5 &&
            props.page - positioncalco + new_li.length <= maxPag;
            i++
        ) {
            if (i >= 0) {
                if (i === props.page)
                    new_li.push(
                        <li className="c-pagination__item" key={'item_' + i}>
                            <span
                                aria-current="page"
                                className="c-pagination__link  is-active"
                                onClick={() => handleChangePage(i)}
                            >
                                {i + 1}
                            </span>
                        </li>
                    );
                else
                    new_li.push(
                        <li className="c-pagination__item" key={'item_' + i}>
                            <span
                                aria-current="page"
                                className="c-pagination__link"
                                onClick={() => handleChangePage(i)}
                            >
                                {i + 1}
                            </span>
                        </li>
                    );
            } else new_li.push(<span key="-----"></span>);
        }
        setli_Pag(new_li);
    }, [props.page, maxPag, props.data]);

    function selectRowIndex(id) {
        for (let elemet in props.data)
            if (props.data[elemet].FinancialOperationCode === id) {
                props.setIndiceRow(parseInt(elemet));
                break;
            }
    }
    function detalledatos(id) {
        setDetalleSelect(id);
        for (let elemet in props.data)
            if (props.data[elemet].FinancialOperationCode === id) {
                props.setIndiceRowDetalle(parseInt(elemet));
                break;
            }
    }

    const handleChangePage = newPage => {
        if (newPage >= 0 && newPage <= maxPag) props.setPage(newPage);
    };

    const handleChangeRowsPerPage = event => {
        props.setrowsPerPage(+event.target.value);
        props.setPage(0);
    };

    function addSelectVencimiento(FinancialOperationCode) {
        var _listSelectVencimiento = JSON.parse(
            JSON.stringify(listSelectVencimiento)
        );
        if (_listSelectVencimiento.includes(FinancialOperationCode))
            _listSelectVencimiento.splice(
                _listSelectVencimiento.indexOf(FinancialOperationCode),
                1
            );
        else _listSelectVencimiento.push(FinancialOperationCode);

        props.setListSelectVencimiento(_listSelectVencimiento);
        props.setIndiceRowDetalle(-1); //-> siempre que marque el chex cierro la vista de detalle
    }

    const showRecompraIrrevocable = productBoxId =>
        [
            ProductBoxId.NEXT,
            ProductBoxId.CPC,
            ProductBoxId.RENTING,
            ProductBoxId.AUTOCREDIT,
        ].includes(productBoxId);

    function changeFavorito(id) {
        for (let elemet in props.data)
            if (props.data[elemet].FinancialOperationCode === id) {
                props.setData(parseInt(elemet));
                break;
            }
        props.setIndiceRowDetalle(-1);
    }
    const pagination = () => {
        return (
            <section className="u-1/1">
                <div className="o-layout__item u-9/12 u-12/12@s">
                    <nav
                        className="c-pagination tablaVencimientos"
                        aria-label="Pagination"
                    >
                        <ul className="c-pagination__list">
                            <li className="c-pagination__item">
                                <a
                                    onClick={() =>
                                        handleChangePage(props.page - 1)
                                    }
                                    className={
                                        (props.page > 0 ? '' : 'is-disabled') +
                                        ' c-pagination__link  c-pagination__link--stepper-prev'
                                    }
                                    style={{
                                        display: 'flex',
                                        position: 'inherit',
                                    }}
                                    title="prev page"
                                ></a>
                            </li>
                            {li_Pag}
                            <li className="c-pagination__item">
                                <a
                                    onClick={() =>
                                        handleChangePage(props.page + 1)
                                    }
                                    className={
                                        (props.page + 1 <= maxPag
                                            ? ''
                                            : 'is-disabled') +
                                        'c-pagination__link  c-pagination__link--stepper-next'
                                    }
                                    style={{ display: 'flex' }}
                                    title="next page"
                                >
                                    <span className="u-visually-hidden">
                                        next page
                                    </span>
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>
                <div
                    className="o-layout__item u-3/12 u-12/12@s c-form-field__box u-text-right"
                    style={{ marginTop: '16px' }}
                >
                    <span
                        style={{ verticalAlign: 'middle', marginRight: '10px' }}
                        className="u-text-brand"
                    >
                        Vctos por página
                    </span>
                    <div
                        className="c-input c-input--select"
                        style={{ width: 'fit-content', float: 'right' }}
                    >
                        <select
                            className="c-input__input"
                            onChange={handleChangeRowsPerPage}
                            defaultValue={props.rowsPerPage}
                        >
                            <option>15</option>
                            <option>30</option>
                            <option>50</option>
                            <option>100</option>
                            <option>1000</option>
                        </select>
                    </div>
                </div>
            </section>
        );
    };

    function colorContacto(tipoProducto, fechaVencimiento) {
        fechaVencimiento = fechaVencimiento.split('/');
        var _fechaVencimiento = new Date(
            fechaVencimiento[1] +
            '/' +
            fechaVencimiento[0] +
            '/' +
            fechaVencimiento[2]
        );
        switch (tipoProducto) {
            case '134 ':
                return _fechaVencimiento < diasAlertContacCPC
                    ? '#FF9317'
                    : '#a8adb3';
            case '158 ':
                return _fechaVencimiento < diasAlertContacNEXT
                    ? '#FF9317'
                    : '#a8adb3';
            case '132 ':
                return _fechaVencimiento < diasAlertContacRENTING
                    ? '#FF9317'
                    : '#a8adb3';
            case '133 ':
                return _fechaVencimiento < diasAlertContacLINEAL
                    ? '#FF9317'
                    : '#a8adb3';
            case '141 ':
                return _fechaVencimiento < diasAlertContacFINANCIACION
                    ? '#FF9317'
                    : '#a8adb3';
            case '168 ':
                return _fechaVencimiento < diasAlertContacREFINANCIACIONNEXT
                    ? '#FF9317'
                    : '#a8adb3';
            case '166 ':
                return _fechaVencimiento < diasAlertContacAUTOCREDIT
                    ? '#FF9317'
                    : '#a8adb3';
        }
    }

    const renderFlagTag = flag => {
        const { label, className } = getFlagDisplay(flag);
        return <div className={`flag-cell ${className}`}>{label}</div>;
    };

    const displaydestoc = () => {
        return (
            <table className="u-hide@l">
                <thead>
                    <tr>
                        <th scope="col" style={{ width: '10px' }}></th>
                        {props.viewDataVencimientoAsignado === true &&
                            /* checkPermission(
                                'CNST_ASIGNACION_VOLUMEN_VENDEDOR'
                            ) &&*/
                            props.user.data.Profile === 12 && (
                                <th scope="col" style={{ width: '10px' }}></th>
                            )}
                        {
                            /*checkPermission('CNST_ASIGNACION_VOLUMEN_VENDEDOR') &&*/
                            props.viewDataVencimientoAsignado && (
                                <th scope="col">Asesor asignado</th>
                            )
                        }
                        {checkPermission('CNST_ASIGNACION_VOLUMEN_VENDEDOR') &&
                            props.viewDataVencimientoAsignado && (
                                <th scope="col">Asesor original</th>
                            )}

                        <th
                            scope="col"
                            style={{ width: '100px' }}
                            className="u-pl-none"
                        >
                            <div
                                className="js-tooltip c-tooltip"
                                data-template={'LeyendaContacto'}
                                style={{
                                    display: 'flex',
                                    alignItems: 'baseline',
                                }}
                            >
                                <span className="u-float-left">
                                    Contactados
                                </span>{' '}
                                <span className="c-icon c-info-icon c-icon--[semantic-info] c-icon--xsmall--table"></span>
                            </div>
                            <LeyendaContactados />
                        </th>
                        <th scope="col">
                            <div
                                className="js-tooltip c-tooltip"
                                data-template={'LeyendaJefeVentas'}
                                style={{
                                    display: 'flex',
                                    alignItems: 'baseline',
                                }}
                            >
                                <span className="u-float-left">
                                    JJVV
                                </span>{' '}
                                <span className="c-icon c-info-icon c-icon--[semantic-info] c-icon--xsmall--table"></span>
                            </div>
                            <LeyendaJJVV />
                        </th>
                        <th scope="col">Matrícula</th>
                        <th scope="col">Marca</th>
                        <th scope="col">Modelo</th>
                        {(!checkPermission(
                            'CNST_ASIGNACION_VOLUMEN_VENDEDOR'
                        ) ||
                            !props.viewDataVencimientoAsignado) && (
                                <th scope="col">Cliente</th>
                            )}
                        <th scope="col" className="u-pr-none u-pl-none">
                            <div className="u-text-center">
                                <div
                                    className="c-icon c-icon--[semantic-user]"
                                    style={{
                                        fontSize: '25px',
                                        paddingBottom: '10px',
                                    }}
                                ></div>
                            </div>
                        </th>
                        <th scope="col" className="u-pl-none">
                            <div className="u-text-center">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="19.006"
                                    height="20"
                                    viewBox="0 0 19.006 15"
                                >
                                    <path
                                        d="M17.578,4.083h-2.1l-.585-1.517A3.921,3.921,0,0,0,11.232,0H6.767A3.923,3.923,0,0,0,3.112,2.567L2.527,4.083H.422a.434.434,0,0,0-.409.544L.224,5.5a.425.425,0,0,0,.409.331h.706a2.353,2.353,0,0,0-.776,1.75v1.75a2.364,2.364,0,0,0,.563,1.529v1.971A1.147,1.147,0,0,0,2.25,14H3.375A1.147,1.147,0,0,0,4.5,12.833V11.667h9v1.167A1.147,1.147,0,0,0,14.625,14H15.75a1.147,1.147,0,0,0,1.125-1.167V10.862a2.362,2.362,0,0,0,.563-1.529V7.583a2.354,2.354,0,0,0-.776-1.75h.706a.425.425,0,0,0,.409-.331l.211-.875A.434.434,0,0,0,17.578,4.083ZM5.02,3.07A1.8,1.8,0,0,1,6.661,1.75h4.677A1.8,1.8,0,0,1,12.98,3.07l.734,2.18H4.286ZM4.086,9.617A1.267,1.267,0,0,1,2.714,8.308,1.267,1.267,0,0,1,4.086,7,2.585,2.585,0,0,1,6.143,8.963C6.143,9.748,4.909,9.617,4.086,9.617Zm9.829,0c-.823,0-2.057.131-2.057-.654A2.585,2.585,0,0,1,13.914,7a1.267,1.267,0,0,1,1.371,1.308,1.267,1.267,0,0,1-1.371,1.308Z"
                                        transform="translate(0.503 0.5)"
                                        fill="#fff"
                                        stroke="black"
                                        strokeWidth="0.4"
                                    />
                                </svg>
                            </div>
                        </th>
                        <th scope="col">
                            {' '}
                            <span></span>Producto
                        </th>
                        <th scope="col"> Recompra Irrevocable</th>
                        <th scope="col"> F.Vcto</th>
                        <th scope="col" className="F_IPO_Table">
                            F.IPO
                        </th>

                        <th scope="col">
                            <div
                                className="js-tooltip c-tooltip"
                                data-template={'LeyendaIncidencia'}
                                style={{
                                    display: 'flex',
                                    alignItems: 'baseline',
                                }}
                            >
                                <span className="u-float-left">
                                    Incidencia
                                </span>{' '}
                                <span className="c-icon c-info-icon c-icon--[semantic-info] c-icon--xsmall--table"></span>
                            </div>
                            <LeyendaContratoIncidencia />
                        </th>

                        {(!checkPermission(
                            'CNST_ASIGNACION_VOLUMEN_VENDEDOR'
                        ) ||
                            !props.viewDataVencimientoAsignado) && (
                                <th scope="col">Asesor original</th>
                            )}
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {dataTable
                        .slice(
                            props.page * props.rowsPerPage,
                            props.page * props.rowsPerPage + props.rowsPerPage
                        )
                        .map((row, indice) => (
                            <tr
                                id={row.FinancialOperationCode + "_" + indice}
                                key={row.FinancialOperationCode + "_" + indice}
                                style={
                                    detalleSelect === row.FinancialOperationCode
                                        ? { backgroundColor: '#f5f7f8' }
                                        : {}
                                }
                            >
                                <th
                                    style={{ minWidth: '10px' }}
                                    className="u-pr-none"
                                >
                                    {row.VendedorAsignado ===
                                        props.user.data.UserId && (
                                            <div
                                                className={
                                                    'fav_' +
                                                    row.FinancialOperationCode + "_" + indice
                                                }
                                                onClick={() => {
                                                    changeFavorito(
                                                        row.FinancialOperationCode + "_" + indice
                                                    );
                                                }}
                                            >
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="14.017"
                                                    height="13.012"
                                                    viewBox="0 0 14.017 13.012"
                                                >
                                                    <g
                                                        id="Path"
                                                        transform="translate(0.509 0.5)"
                                                    >
                                                        <path
                                                            id="Path-2"
                                                            data-name="Path"
                                                            d="M13.486,5.065h0a.3.3,0,0,0-.261-.2L8.966,4.492l-.1-.233L7.281.677a.312.312,0,0,0-.562,0L5.034,4.492l-.256.022-4,.352a.3.3,0,0,0-.262.2.272.272,0,0,0,.086.3L3.825,8.1l-.059.253-.892,3.8a.275.275,0,0,0,.114.29.315.315,0,0,0,.341.014L7,10.334l.219.127,3.452,2a.317.317,0,0,0,.34-.014.276.276,0,0,0,.115-.29L10.174,8.1l.2-.169L13.4,5.362A.273.273,0,0,0,13.486,5.065Z"
                                                            transform="translate(-0.5 -0.5)"
                                                            fill={
                                                                row.Fravorito ===
                                                                    '1'
                                                                    ? '#66e4ee'
                                                                    : '#fff'
                                                            }
                                                            stroke={
                                                                row.Fravorito ===
                                                                    '1'
                                                                    ? '#66e4ee'
                                                                    : '#d8d8d8'
                                                            }
                                                            strokeWidth="1"
                                                        />
                                                    </g>
                                                </svg>
                                            </div>
                                        )}
                                </th>
                                {props.viewDataVencimientoAsignado === true &&
                                    props.user.data.Profile === 12 && (
                                        <th className="u-pr-none">
                                            {(checkPermission(
                                                'CNST_ASIGNACION_VOLUMEN_VENDEDOR'
                                            ) ||
                                                row.VendedorAsignado ===
                                                null) && (
                                                    <label className="c-checkbox">
                                                        <input
                                                            className="c-checkbox__input"
                                                            type="checkbox"
                                                            name="checkbox"
                                                            id={
                                                                'checkboxTableVencimienti' +
                                                                row.FinancialOperationCode
                                                            }
                                                            checked={
                                                                listSelectVencimiento.length >
                                                                    0 &&
                                                                    listSelectVencimiento.includes(
                                                                        row.FinancialOperationCode
                                                                    )
                                                                    ? true
                                                                    : false
                                                            }
                                                            onChange={() =>
                                                                addSelectVencimiento(
                                                                    row.FinancialOperationCode
                                                                )
                                                            }
                                                        />
                                                        <span className="c-checkbox__label"></span>
                                                    </label>
                                                )}
                                        </th>
                                    )}
                                {
                                    /*checkPermission(
                                    'CNST_ASIGNACION_VOLUMEN_VENDEDOR'
                                ) &&*/
                                    props.viewDataVencimientoAsignado && (
                                        <td className="u-text-truncate">
                                            {row.VendedorAsignado !== null
                                                ? new FunctionGeneral().capitalizeText(
                                                    row.VendedorAsignado.split(
                                                        ' '
                                                    )
                                                )
                                                : ''}
                                        </td>
                                    )
                                }
                                {checkPermission(
                                    'CNST_ASIGNACION_VOLUMEN_VENDEDOR'
                                ) &&
                                    props.viewDataVencimientoAsignado && (
                                        <td
                                            scope="row"
                                            className="u-text-truncate"
                                            onClick={() =>
                                                detalledatos(
                                                    row.FinancialOperationCode
                                                )
                                            }
                                        >
                                            {new FunctionGeneral().capitalizeText(
                                                row.SellerContractsFullName.split(
                                                    ' '
                                                )
                                            )}
                                        </td>
                                    )}
                                <td //dkxewh5
                                    className="u-text-center"
                                    onClick={() =>
                                        detalledatos(row.FinancialOperationCode)
                                    }
                                >
                                    {row.Gestionado === 'S' ? (
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="14.795"
                                            height="14.71"
                                            viewBox="0 0 14.795 14.71"
                                        >
                                            <g
                                                id="_08_Icons_01_Control-16x16_01_Control-phone"
                                                data-name="08_Icons/01_Control-16x16/01_Control-phone"
                                                transform="translate(-0.555 -0.65)"
                                            >
                                                <path
                                                    id="Shape"
                                                    d="M11.3,15.1A11.318,11.318,0,0,1,4.1,12C1.3,9.1-.1,4.3,1.5,2.3L2.9.9H5.1L6.6,5,4.8,6.7A5.88,5.88,0,0,0,6.5,9.5a5.47,5.47,0,0,0,2.8,1.7L11,9.5l4.1,1.4V13l-1.4,1.4A3.612,3.612,0,0,1,11.3,15.1ZM3.3,1.8,2.2,2.9c-1.1,1.4,0,5.7,2.7,8.3,2.5,2.6,6.7,3.6,8.2,2.5l1-1V11.6l-2.9-1L9.6,12.2H9.5c-.1,0-1.7,0-3.6-2-2-2-2-3.6-2-3.6V6.4L5.5,4.8l-1.1-3Z"
                                                    fill="green"
                                                    stroke="green"
                                                    strokeWidth="0.5"
                                                />
                                            </g>
                                        </svg>
                                    ) : (
                                        <div>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="14.795"
                                                height="15.307"
                                                viewBox="0 0 14.795 15.307"
                                            >
                                                <g
                                                    id="Grupo_68432"
                                                    data-name="Grupo 68432"
                                                    transform="translate(-8.969 -12.469)"
                                                >
                                                    <g
                                                        id="_08_Icons_01_Control-16x16_01_Control-phone-Copy-9"
                                                        data-name="08_Icons/01_Control-16x16/01_Control-phone-Copy-9"
                                                        transform="translate(9.24 12.719)"
                                                    >
                                                        <path
                                                            id="Shape"
                                                            d="M11.3,15.1A11.318,11.318,0,0,1,4.1,12C1.3,9.1-.1,4.3,1.5,2.3L2.9.9H5.1L6.6,5,4.8,6.7A5.88,5.88,0,0,0,6.5,9.5a5.47,5.47,0,0,0,2.8,1.7L11,9.5l4.1,1.4V13l-1.4,1.4A3.612,3.612,0,0,1,11.3,15.1ZM3.3,1.8,2.2,2.9c-1.1,1.4,0,5.7,2.7,8.3,2.5,2.6,6.7,3.6,8.2,2.5l1-1V11.6l-2.9-1L9.6,12.2H9.5c-.1,0-1.7,0-3.6-2-2-2-2-3.6-2-3.6V6.4L5.5,4.8l-1.1-3Z"
                                                            transform="translate(-0.826 -0.9)"
                                                            fill={colorContacto(
                                                                row.ProductBoxId,
                                                                row.ExpirationDate
                                                            )}
                                                            stroke={colorContacto(
                                                                row.ProductBoxId,
                                                                row.ExpirationDate
                                                            )}
                                                            strokeWidth="0.5"
                                                        />
                                                    </g>
                                                </g>
                                            </svg>
                                        </div>
                                    )}
                                </td>

                                <td
                                    onClick={() =>
                                        detalledatos(row.FinancialOperationCode)
                                    }
                                >

                                    {row.DecisionJJVV === 'SN' && (
                                        <img src={correoEnviadoIcon} style={{ height: "30px" }}></img>
                                    )
                                    }


                                    {row.DecisionJJVV === 'SP' && (
                                        <img src={correoAbiertoIcon} style={{ height: "30px" }}></img>
                                    )
                                    }
                                </td>

                                <td
                                    onClick={() =>
                                        detalledatos(row.FinancialOperationCode)
                                    }
                                >
                                    {row.VehiclePlate}
                                </td>
                                <td
                                    onClick={() =>
                                        detalledatos(row.FinancialOperationCode)
                                    }
                                    className="u-text-truncate marcaTruncate"
                                >
                                    {row.BrandDescription}
                                </td>
                                <td
                                    scope="row"
                                    className="u-text-truncate"
                                    onClick={() =>
                                        detalledatos(row.FinancialOperationCode)
                                    }
                                >
                                    {new FunctionGeneral().capitalizeText(
                                        row.VehicleModelDescription.split(' ')
                                    )}
                                </td>
                                {(!checkPermission(
                                    'CNST_ASIGNACION_VOLUMEN_VENDEDOR'
                                ) ||
                                    !props.viewDataVencimientoAsignado) && (
                                        <td
                                            scope="row"
                                            className="u-text-truncate"
                                            onClick={() =>
                                                detalledatos(
                                                    row.FinancialOperationCode
                                                )
                                            }
                                        >
                                            {new FunctionGeneral().capitalizeText(
                                                row.TitularFullName.split(' ')
                                            )}
                                        </td>
                                    )}
                                <td
                                    className="u-pl-none u-pr-none"
                                    onClick={() =>
                                        detalledatos(row.FinancialOperationCode)
                                    }
                                >
                                    {new FunctionGeneral().EsferaColor(
                                        row.CustomerVehicleCategory[0]
                                    )}
                                </td>
                                <td
                                    className="u-pl-none"
                                    onClick={() =>
                                        detalledatos(row.FinancialOperationCode)
                                    }
                                >
                                    {new FunctionGeneral().EsferaColor(
                                        row.CustomerVehicleCategory[1]
                                    )}
                                </td>
                                <td
                                    onClick={() =>
                                        detalledatos(row.FinancialOperationCode)
                                    }
                                >
                                    {new FunctionGeneral().Producto(
                                        row.ProductBoxId
                                    )}
                                </td>
                                <td className="compra-irrevocable-col">
                                   {showRecompraIrrevocable(row.ProductBoxId) ? renderFlagTag(row.Flag) : null}
                                </td>
                                <td
                                    onClick={() =>
                                        detalledatos(row.FinancialOperationCode)
                                    }
                                >
                                    {row.ExpirationDate}
                                </td>
                                <td
                                    className="F_IPO_Table"
                                    onClick={() =>
                                        detalledatos(row.FinancialOperationCode)
                                    }
                                >
                                    {row.IPODate}
                                </td>
                                <td
                                    className="CONT_INC_Table"
                                    onClick={() =>
                                        detalledatos(row.FinancialOperationCode)
                                    }
                                >
                                    {row.ContratoIncidencias === "S" && (
                                        <img src={oipIcon} style={{ height: "35px" }}></img>
                                    )}
                                </td>

                                {(!checkPermission(
                                    'CNST_ASIGNACION_VOLUMEN_VENDEDOR'
                                ) ||
                                    !props.viewDataVencimientoAsignado) && (
                                        <td
                                            scope="row"
                                            className="u-text-truncate"
                                            onClick={() =>
                                                detalledatos(
                                                    row.FinancialOperationCode
                                                )
                                            }
                                        >
                                            {new FunctionGeneral().capitalizeText(
                                                row.SellerContractsFullName.split(
                                                    ' '
                                                )
                                            )}
                                        </td>
                                    )}
                                <td>
                                    <button
                                        className="c-icon c-icon--[control-eye]"
                                        style={{ display: 'grid' }}
                                        onClick={() =>
                                            selectRowIndex(
                                                row.FinancialOperationCode
                                            )
                                        }
                                    ></button>
                                </td>
                            </tr>
                        ))}
                </tbody>
            </table>
        );
    };

    const displayResponse = () => {
        return (
            <div className="u-hide@l-up">
                {dataTable
                    .slice(
                        props.page * props.rowsPerPage,
                        props.page * props.rowsPerPage + props.rowsPerPage
                    )
                    .map((row, indice) => (
                        <div
                            className="c-card"
                            key={row.FinancialOperationCode + 'c-card' + '_' + indice}
                        >
                            <header className="c-card__header">
                                {row.VendedorAsignado ===
                                    props.user.data.UserId && (
                                        <div
                                            className={
                                                'fav_' +
                                                row.FinancialOperationCode +
                                                ' u-float-left'
                                            }
                                            onClick={() => {
                                                changeFavorito(indice);
                                            }}
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="14.017"
                                                height="13.012"
                                                viewBox="0 0 14.017 13.012"
                                            >
                                                <g transform="translate(0.509 0.5)">
                                                    <path
                                                        d="M13.486,5.065h0a.3.3,0,0,0-.261-.2L8.966,4.492l-.1-.233L7.281.677a.312.312,0,0,0-.562,0L5.034,4.492l-.256.022-4,.352a.3.3,0,0,0-.262.2.272.272,0,0,0,.086.3L3.825,8.1l-.059.253-.892,3.8a.275.275,0,0,0,.114.29.315.315,0,0,0,.341.014L7,10.334l.219.127,3.452,2a.317.317,0,0,0,.34-.014.276.276,0,0,0,.115-.29L10.174,8.1l.2-.169L13.4,5.362A.273.273,0,0,0,13.486,5.065Z"
                                                        transform="translate(-0.5 -0.5)"
                                                        fill={
                                                            row.Fravorito === '1'
                                                                ? '#66e4ee'
                                                                : '#fff'
                                                        }
                                                        stroke={
                                                            row.Fravorito === '1'
                                                                ? '#66e4ee'
                                                                : '#d8d8d8'
                                                        }
                                                        strokeWidth="1"
                                                    />
                                                </g>
                                            </svg>
                                        </div>
                                    )}
                                {props.viewDataVencimientoAsignado === true &&
                                    (checkPermission(
                                        'CNST_ASIGNACION_VOLUMEN_VENDEDOR'
                                    ) ||
                                        row.VendedorAsignado === null) &&
                                    props.user.data.Profile === 12 && (
                                        <label
                                            className="c-checkbox u-float-left"
                                            style={{ marginLeft: '15px' }}
                                        >
                                            <input
                                                className="c-checkbox__input"
                                                type="checkbox"
                                                name="checkbox"
                                                id={
                                                    'checkboxTableVencimienti' +
                                                    row.FinancialOperationCode
                                                }
                                                checked={
                                                    listSelectVencimiento.length >
                                                        0 &&
                                                        listSelectVencimiento.includes(
                                                            row.FinancialOperationCode
                                                        )
                                                        ? true
                                                        : false
                                                }
                                                onChange={() =>
                                                    addSelectVencimiento(
                                                        row.FinancialOperationCode,
                                                        row.BrandDescription
                                                    )
                                                }
                                            />
                                            <span className="c-checkbox__label">
                                                Selecciona para asignar
                                            </span>
                                        </label>
                                    )}
                                <div
                                    className="u-float-right"
                                    onClick={() =>
                                        selectRowIndex(
                                            row.FinancialOperationCode
                                        )
                                    }
                                >
                                    <svg
                                        id="Shape"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="30.747"
                                        height="16.67"
                                        viewBox="0 0 20.747 11.67"
                                    >
                                        <path
                                            id="Shape-2"
                                            data-name="Shape"
                                            d="M10.373,14.546A3.242,3.242,0,1,1,13.615,11.3a3.242,3.242,0,0,1-3.242,3.242Zm0-5.187A1.945,1.945,0,1,0,12.318,11.3a1.945,1.945,0,0,0-1.945-1.945Zm0,7.78C4.8,17.139,0,13.226,0,11.3,0,9.432,4.908,5.469,10.373,5.469S20.747,9.432,20.747,11.3,15.839,17.139,10.373,17.139Zm0-10.373c-5.168,0-9.034,3.786-9.077,4.54,0,.917,3.969,4.536,9.077,4.536,5.164,0,9.028-3.779,9.077-4.538C19.4,10.545,15.537,6.766,10.373,6.766Z"
                                            transform="translate(0 -5.469)"
                                            fill="#004666"
                                            fillRule="evenodd"
                                        />
                                    </svg>
                                </div>
                            </header>

                            <div className="c-card__body">
                                <div className="u-1/4 u-hide@s u-float-left">
                                    <label className="labelConsT u-text-base u-1/1">
                                        Vehículo
                                    </label>
                                    {row.VehiclePlate !== null && (
                                        <label className="labelConsT u-text-muted u-1/1">
                                            {row.VehiclePlate}
                                        </label>
                                    )}
                                    {row.TMAIMG !== null && (
                                        <label className="labelConsT u-text-muted u-1/1">
                                            {row.TMAIMG}
                                        </label>
                                    )}
                                    {row.VehicleModelDescription !== null && (
                                        <label className="labelConsT u-text-muted u-1/1">
                                            {new FunctionGeneral().capitalizeText(
                                                row.VehicleModelDescription.split(
                                                    ' '
                                                )
                                            )}
                                        </label>
                                    )}
                                    {row.VehicleIdentificationNumber !==
                                        null && (
                                            <label className="labelConsT u-text-muted u-1/1">
                                                {row.VehicleIdentificationNumber}
                                            </label>
                                        )}
                                </div>
                                <div className="u-1/4 u-1/2@s u-1/2@xs u-float-left">
                                    <label className="labelConsT u-text-base u-1/1">
                                        Producto
                                    </label>
                                    <div style={{ marginBottom: '5px' }}>
                                        {new FunctionGeneral().Producto(
                                            row.ProductBoxId
                                        )}
                                    </div>
                                    {row.IPODate !== null && (
                                        <label className="labelConsT u-text-base u-1/1">
                                            Fecha Ipo
                                        </label>
                                    )}
                                    {row.IPODate !== null && (
                                        <label className="labelConsT u-text-muted u-1/1">
                                            {row.IPODate}
                                        </label>
                                    )}
                                    <label className="labelConsT u-text-base u-1/1">
                                        Cliente
                                    </label>
                                    {row.TitularNIF !== null && (
                                        <label className="labelConsT u-text-muted u-1/1">
                                            {row.TitularNIF}
                                        </label>
                                    )}
                                    {row.TitularFullName !== null && (
                                        <label className="labelConsT u-text-muted u-1/1 u-text-capitalize">
                                            {new FunctionGeneral().capitalizeText(
                                                row.TitularFullName.split(' ')
                                            )}
                                        </label>
                                    )}
                                     {showRecompraIrrevocable(row.ProductBoxId) && (
                                        <label className="labelConsT u-text-base u-1/1">
                                            Recompra Irrevocable
                                        </label>
                                    )}
                                    {showRecompraIrrevocable(row.ProductBoxId) && (
                                        <label className="labelConsT u-text-muted u-1/1">
                                            {getFlagDisplay(row.Flag).label}
                                        </label>
                                    )}
                                    {/* {
                                        <label className="labelConsT u-text-muted u-1/1">
                                            {getFlagDisplay(row.Flag).label}
                                        </label>
                                    } */}
                                </div>
                                <div className="u-1/4 u-1/2@s u-1/2@xs u-float-left">
                                    <div
                                        className="u-text-left"
                                        style={{ marginBottom: '10px' }}
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="15.47"
                                            height="15.777"
                                            viewBox="0 0 11.47 15.777"
                                        >
                                            <path
                                                d="M9,7.88A3.38,3.38,0,1,1,12.375,4.5,3.38,3.38,0,0,1,9,7.88ZM9,2.245A2.255,2.255,0,1,0,11.25,4.5,2.255,2.255,0,0,0,9,2.245ZM12.794,16.9H5.206L3.265,10.425l.413-.215A11.277,11.277,0,0,1,9,9a11.491,11.491,0,0,1,5.322,1.21l.413.215Zm-6.75-1.125h5.913l1.43-4.765A10.625,10.625,0,0,0,9,10.125a10.215,10.215,0,0,0-4.387.88Z"
                                                transform="translate(-3.265 -1.12)"
                                                fill="black"
                                                fillRule="evenodd"
                                            />
                                        </svg>

                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="19.006"
                                            height="15"
                                            viewBox="0 0 19.006 15"
                                        >
                                            <path
                                                d="M17.578,4.083h-2.1l-.585-1.517A3.921,3.921,0,0,0,11.232,0H6.767A3.923,3.923,0,0,0,3.112,2.567L2.527,4.083H.422a.434.434,0,0,0-.409.544L.224,5.5a.425.425,0,0,0,.409.331h.706a2.353,2.353,0,0,0-.776,1.75v1.75a2.364,2.364,0,0,0,.563,1.529v1.971A1.147,1.147,0,0,0,2.25,14H3.375A1.147,1.147,0,0,0,4.5,12.833V11.667h9v1.167A1.147,1.147,0,0,0,14.625,14H15.75a1.147,1.147,0,0,0,1.125-1.167V10.862a2.362,2.362,0,0,0,.563-1.529V7.583a2.354,2.354,0,0,0-.776-1.75h.706a.425.425,0,0,0,.409-.331l.211-.875A.434.434,0,0,0,17.578,4.083ZM5.02,3.07A1.8,1.8,0,0,1,6.661,1.75h4.677A1.8,1.8,0,0,1,12.98,3.07l.734,2.18H4.286ZM4.086,9.617A1.267,1.267,0,0,1,2.714,8.308,1.267,1.267,0,0,1,4.086,7,2.585,2.585,0,0,1,6.143,8.963C6.143,9.748,4.909,9.617,4.086,9.617Zm9.829,0c-.823,0-2.057.131-2.057-.654A2.585,2.585,0,0,1,13.914,7a1.267,1.267,0,0,1,1.371,1.308,1.267,1.267,0,0,1-1.371,1.308Z"
                                                transform="translate(0.503 0.5)"
                                                fill="#fff"
                                                stroke="black"
                                                strokeWidth="1"
                                            />
                                        </svg>
                                    </div>
                                    <div style={{ display: 'flex' }}>
                                        {new FunctionGeneral().EsferaColor(
                                            row.CustomerVehicleCategory[0]
                                        )}
                                        <span style={{ marginLeft: '2px' }}>
                                            {new FunctionGeneral().EsferaColor(
                                                row.CustomerVehicleCategory[1]
                                            )}
                                        </span>
                                    </div>
                                    <label
                                        className="labelConsT u-text-base u-1/1"
                                        style={{ marginTop: '15px' }}
                                    >
                                        Fecha de Vencimientio
                                    </label>
                                    {row.ExpirationDate !== null && (
                                        <label className="labelConsT u-text-muted u-1/1">
                                            {row.ExpirationDate}
                                        </label>
                                    )}
                                    <label
                                        className="labelConsT u-text-base u-1/1"
                                        style={{ marginTop: '15px' }}
                                    >
                                        Asesor original
                                    </label>
                                    {row.SellerContractsFullName !== null && (
                                        <label className="labelConsT u-text-muted u-1/1 u-text-capitalize">
                                            {new FunctionGeneral().capitalizeText(
                                                row.SellerContractsFullName.split(
                                                    ' '
                                                )
                                            )}
                                        </label>
                                    )}
                                </div>
                                <div className="u-hide@s-up u-1/2 u-float-left">
                                    <label
                                        className="labelConsT u-text-base u-1/1"
                                        style={{ marginTop: '15px' }}
                                    >
                                        Vehículo
                                    </label>
                                    {row.VehiclePlate !== null && (
                                        <label className="labelConsT u-text-muted u-1/1">
                                            {row.VehiclePlate}
                                        </label>
                                    )}
                                    {row.TMAIMG !== null && (
                                        <label className="labelConsT u-text-muted u-1/1">
                                            {row.TMAIMG}
                                        </label>
                                    )}
                                    {row.VehicleModelDescription !== null && (
                                        <label className="labelConsT u-text-muted u-1/1">
                                            {new FunctionGeneral().capitalizeText(
                                                row.VehicleModelDescription.split(
                                                    ' '
                                                )
                                            )}
                                        </label>
                                    )}
                                    {row.VehicleIdentificationNumber !==
                                        null && (
                                            <label className="labelConsT u-text-muted u-1/1">
                                                {row.VehicleIdentificationNumber}
                                            </label>
                                        )}
                                </div>
                                <div
                                    className="u-1/4 u-1/2@s u-1/2@xs u-float-left"
                                    style={{ marginBottom: '15px' }}
                                >
                                    <label className="labelConsT u-text-base u-1/1">
                                        Operación
                                    </label>
                                    {row.FinancialOperationCode !== null && (
                                        <label className="labelConsT u-text-muted u-1/1">
                                            {row.FinancialOperationCode}
                                        </label>
                                    )}
                                </div>
                                <div
                                    className="u-1/4 u-1/2@s u-1/2@xs u-float-left"
                                    style={{ marginBottom: '15px' }}
                                >
                                    <label className="labelConsT u-text-base u-1/1">
                                        Contactado
                                    </label>
                                    {row.FinancialOperationCode !== null &&
                                        (row.Gestionado === 'S' ? (
                                            <div className="u-text-left">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="14.795"
                                                    height="14.71"
                                                    viewBox="0 0 14.795 14.71"
                                                >
                                                    <g
                                                        id="_08_Icons_01_Control-16x16_01_Control-phone"
                                                        data-name="08_Icons/01_Control-16x16/01_Control-phone"
                                                        transform="translate(-0.555 -0.65)"
                                                    >
                                                        <path
                                                            id="Shape"
                                                            d="M11.3,15.1A11.318,11.318,0,0,1,4.1,12C1.3,9.1-.1,4.3,1.5,2.3L2.9.9H5.1L6.6,5,4.8,6.7A5.88,5.88,0,0,0,6.5,9.5a5.47,5.47,0,0,0,2.8,1.7L11,9.5l4.1,1.4V13l-1.4,1.4A3.612,3.612,0,0,1,11.3,15.1ZM3.3,1.8,2.2,2.9c-1.1,1.4,0,5.7,2.7,8.3,2.5,2.6,6.7,3.6,8.2,2.5l1-1V11.6l-2.9-1L9.6,12.2H9.5c-.1,0-1.7,0-3.6-2-2-2-2-3.6-2-3.6V6.4L5.5,4.8l-1.1-3Z"
                                                            fill="green"
                                                            stroke="green"
                                                            strokeWidth="0.5"
                                                        />
                                                    </g>
                                                </svg>
                                            </div>
                                        ) : (
                                            <div className="u-text-left">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="14.795"
                                                    height="15.307"
                                                    viewBox="0 0 14.795 15.307"
                                                >
                                                    <g
                                                        id="Grupo_68432"
                                                        data-name="Grupo 68432"
                                                        transform="translate(-8.969 -12.469)"
                                                    >
                                                        <g
                                                            id="_08_Icons_01_Control-16x16_01_Control-phone-Copy-9"
                                                            data-name="08_Icons/01_Control-16x16/01_Control-phone-Copy-9"
                                                            transform="translate(9.24 12.719)"
                                                        >
                                                            <path
                                                                id="Shape"
                                                                d="M11.3,15.1A11.318,11.318,0,0,1,4.1,12C1.3,9.1-.1,4.3,1.5,2.3L2.9.9H5.1L6.6,5,4.8,6.7A5.88,5.88,0,0,0,6.5,9.5a5.47,5.47,0,0,0,2.8,1.7L11,9.5l4.1,1.4V13l-1.4,1.4A3.612,3.612,0,0,1,11.3,15.1ZM3.3,1.8,2.2,2.9c-1.1,1.4,0,5.7,2.7,8.3,2.5,2.6,6.7,3.6,8.2,2.5l1-1V11.6l-2.9-1L9.6,12.2H9.5c-.1,0-1.7,0-3.6-2-2-2-2-3.6-2-3.6V6.4L5.5,4.8l-1.1-3Z"
                                                                transform="translate(-0.826 -0.9)"
                                                                fill={colorContacto(
                                                                    row.ProductBoxId,
                                                                    row.ExpirationDate
                                                                )}
                                                                stroke={colorContacto(
                                                                    row.ProductBoxId,
                                                                    row.ExpirationDate
                                                                )}
                                                                strokeWidth="0.5"
                                                            />
                                                        </g>
                                                    </g>
                                                </svg>
                                            </div>
                                        ))}
                                </div>
                                <div
                                    className="u-1/4 u-1/2@s u-1/2@xs u-float-left"
                                    style={{ marginBottom: '15px' }}
                                >
                                    <label className="labelConsT u-text-base u-1/1">
                                        Incidencia
                                    </label>
                                    {row.ContratoIncidencias === "S" && (
                                        <img src={oipIcon} style={{ display: "block", height: "35px" }}></img>
                                    )}
                                </div>

                                {checkPermission(
                                    'CNST_ASIGNACION_VOLUMEN_VENDEDOR'
                                ) && (
                                        <div className="u-1/4 u-1/2@s u-1/2@xs u-float-left">
                                            <label className="labelConsT u-text-base u-1/1">
                                                Asesor asignado
                                            </label>
                                            <label className="labelConsT u-text-muted u-1/1">
                                                {row.VendedorAsignado !== null
                                                    ? new FunctionGeneral().capitalizeText(
                                                        row.VendedorAsignado.split(
                                                            ' '
                                                        )
                                                    )
                                                    : ''}
                                            </label>
                                        </div>
                                    )}
                            </div>
                        </div>
                    ))}
            </div>
        );
    };

    const descargaExcel = () => {
        return (
            <div className="sg-component-variant">
                <button
                    disabled={props.data.length > 0 ? false : true}
                    className="c-btn c-btn--icon js-tooltip"
                    data-tippy-content={
                        'Descargar el listado de vencimientos' +
                        (props.viewDataVencimientoAsignado
                            ? ' completo'
                            : ' asignados') +
                        '. La lista descargada conservara el orden y filtros seleccionados.'
                    }
                        onClick={async () => {
                            if (props.onExportExcel)
                                await props.onExportExcel({
                                    viewDataVencimientoAsignado:
                                        props.viewDataVencimientoAsignado,
                                    orden: props.orden,
                                    filterAsignados: props.filterAsignados,
                                    filtermatriculAsignados:
                                        props.filtermatriculAsignados,
                                });
                        }}
                >
                    <i
                        className="c-btn__icon c-icon  c-icon--[semantic-download]"
                        aria-hidden="true"
                        role="img"
                    ></i>
                    <span className="c-btn__text">
                        Listado{' '}
                        {props.viewDataVencimientoAsignado
                            ? 'completo'
                            : 'asignados'}
                    </span>
                </button>
            </div>
        );
    };

    return (
        <div className="u-1/1 c-table-wrapper c-table--wide tablaVencimientos">
            {displaydestoc()}
            {displayResponse()}
            {pagination()}
            {descargaExcel()}
        </div>
    );
}

export default withRouter(TablaVencimientos);
